<template>
  <div class="main-box main-content">
      <el-form ref="dataForm" id="dataForm" :model="temp" :rules="rules" label-width="100px" label-suffix="：">
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item  label="数据源名称" prop="dataSourceName">
              <el-input v-model="temp.dataSourceName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item  label="描述">
              <el-input type="textarea" v-model="temp.description"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="">
        <xr-button type="primary" @click="save('dataForm')">确定</xr-button>
        <xr-button type="default" @click="dialogVisible = false">取消</xr-button>
      </div>
  </div>
</template>

<script>

export default {
  name: "partyBSelect",
  data() {
    return {
      dialogName: '新增',
      dialogVisible: false,                                        //弹框
      type: 'edit',                                                //类型
      temp:{
        id: '',                                                    //主键ID
        dataSourceName: '',                                           //标题
        description: '',                                                //描述
      },
      rules: {
        dataSourceName: [
          { message: '数据源不能为空!', required: true, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init(type, id){
      if(type === 'edit'){
        this.dialogName = '修改';
      }else{
        this.dialogName = '新增';
      }
      this.dialogVisible = true;
      this.temp.id = id;
      this.type = type;
      return this.request({
        method:'post',
        url:'/web/service',
        params:{
          'method': 'tBiDataSource_getPageInfo',
          type: type,
          id: id
        }
      }).then((response) =>{          //这里使用了ES6的语法
        // 请求成功返回的数据
        //如果返回编码不为0，提示失败语
        if(response.code != '0'){
          this.$message.error(response.msg);
          return false;
        }
        if(response.data && response.data.info){
          this.temp = response.data.info;
        }
      })
    },
    save(formName){
      let url = '/web/service?method=tBiDataSource_edit'
      if(this.type === 'save'){
        url = '/web/service?method=tBiDataSource_save'
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          return this.request({
            method: 'post',
            url: url,
            params: this.temp
          }).then((response) =>{
            if (response.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.dialogVisible = false
                  this.$emit('refreshData');
                }
              })
            } else {
              this.$message.error(response.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //重置
    resetTemp() {
      this.temp.id = '';
      this.temp.dataSourceName = '';
      this.temp.orderNo = '';
      this.$nextTick(() => {      //清空校验
        this.$refs['dataForm'].clearValidate()
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/bi/base/dataGroup/model/model-designer.vue